<section class="content">
    <div class="card" style="padding:25px">
        <div class="row">
            <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
                {{title}}
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                <label>First Date</label>
                <input type="date" [(ngModel)]="selected_from_date" (ngModelChange)="changeEvent()"
                    class="main-border-class">
            </div>
            <div class="col-2">
                <label>Second Date</label>
                <input type="date" [(ngModel)]="selected_to_date" class="main-border-class" disabled>
            </div>

            <div class="col-2" style="text-align: center; padding: 35px;">
                <button mat-button class="button-class"
                    [disabled]="selected_from_date == null || selected_to_date == null "
                    (click)="getClicked()">Get</button>
            </div>
            <div class="col-2" *ngIf="!is_document_available">
                <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
                </mat-progress-spinner>
            </div>
            <div class="col-2" *ngIf="document_file!== null && is_document_available">
                <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top: 28px;"><i
                        class="material-icons">
                        get_app
                    </i> Download Excel</button>
            </div>

            <div class="col-2" *ngIf="document_file!== null && is_document_available">
                <button mat-button class="button-class" (click)="downloadClickedpdf()" style="margin-top: 28px;"><i
                        class="material-icons">
                        get_app
                    </i> Download pdf</button>
            </div>
        </div>
    </div>
</section>